// KeyboardControl --------------------------------------------
function KeyboardControl() {

	//Import classes
	var EventDispatcher = include('springroll.EventDispatcher');

	this.ev_disp = new EventDispatcher();
	this.allowControls = false;
		
	// used to initialize the controls
	this.init = function() {
		// set up keyboard access of drone
		window.addEventListener('keydown', this.onKeyPressed.bind(this), false);
	};

	// used to detect when an arrow key is pressed
	this.onKeyPressed = function(ev) {
		if(!this.allowControls){return;}		
		// check for up arrow
		if(ev.keyCode === 38) {
			ev.preventDefault();
			this.ev_disp.trigger('KEY_PRESSED', {type:'UP'});
		}
		// check for down arrow
		if(ev.keyCode === 40) {
			ev.preventDefault();
			this.ev_disp.trigger('KEY_PRESSED', {type:'DOWN'});	
		}
		// check for left arrow
		if(ev.keyCode === 37) {
			ev.preventDefault();
			this.ev_disp.trigger('KEY_PRESSED', {type:'LEFT'});	
		}
		// check for right arrow
		if(ev.keyCode === 39) {
			ev.preventDefault();
			this.ev_disp.trigger('KEY_PRESSED', {type:'RIGHT'});	
		}
		// check for tab key
/*		if(ev.keyCode === 9) {
			ev.preventDefault();
			this.ev_disp.trigger('KEY_PRESSED', {type:'TAB'});	
		}
*/	};	
	// used to enable the keyboard control
	this.enableControls = function() {
		this.allowControls = true;
	};
	
	// used to disable the keyboard control
	this.disableControls = function() {
		this.allowControls = false;		
	};
	
	this.init();
}

namespace('WGBH').KeyboardControl = KeyboardControl;

